var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraPanoramaSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    width: "800px",
    height: "800px",
    viewBox: "0 0 14 14",
    role: "img",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 5.108323,2.6602375 3.8001485,0 0,8.6486495 -3.8001485,0 z M 13,12.574907 l 0,-5.5749095 0,-5.57489 c 0,-0.19298 -0.20155,-0.31974 -0.375498,-0.23616 l -3.124192,1.50138 0,4.30966 0,4.3096895 3.124205,1.50136 C 12.79845,12.894637 13,12.767877 13,12.574907 Z m -11.6245022,0.23615 3.1242053,-1.50138 0,-4.3096795 0,-4.30967 -3.1242053,-1.50138 C 1.2015633,1.1053575 1,1.2321175 1,1.4251075 l 0,5.57489 0,5.5749095 c 0,0.19297 0.2015633,0.31973 0.3754978,0.23615 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraPanoramaSvgrepoCom);
export default __webpack_public_path__ + "static/media/camera-panorama-svgrepo-com.18daa330545a4f43762c1fdf2c2ea7c5.svg";
export { ForwardRef as ReactComponent };